function date(args) {
  return new Date().toString();
}

export { date };
